var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconDrive({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.31396 24.9125L9.39093 17.675H25.7001L21.6227 24.9125H5.31396Z",
    fill: "#3777E3"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.5457 17.675H25.7L17.5457 3.2H9.39087L17.5457 17.675Z",
    fill: "#FFCF63"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.23633 17.675L5.31384 24.9125L13.4681 10.4375L9.3908 3.2L1.23633 17.675Z",
    fill: "#11A861"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDrive);
export default __webpack_public_path__ + "static/media/icon_drive.2dcdd83ae6a1d23cc714ae31289fa19c.svg";
export { ForwardRef as ReactComponent };